export default __webpack_public_path__ + "static/media/android.37945723.svg";